<template>
    <div class="m-x-3-lg m-x-2-md m-y-2-md">
        <span class="titulo-seccion">Principios del Manejo Ecológico Integral de Arvenses (MEIA)</span>
        <h1 class="titulo">Materiales de divulgación</h1>

        <div class="contenedor-documentos">
            <DownloadFile
                file="descargables/alternativas/materiales/Escalona Aguilar et al., 2021. Agricultura sin Glifosato.pdf"
                type="appdivcation/pdf"
                format="PDF"
                name="Agricultura sin Glifosato"
                downloadname="Escalona Aguilar et al., 2021. Agricultura sin Glifosato.pdf"
                weight="6 MB"
                cover="descargables/alternativas/materiales/cover-agri-sin-glifosato.png" />
            <DownloadFile
                file="descargables/alternativas/materiales/Ramirez-Muños, 2021. El herbicida glifosato y sus alternativas.pdf"
                type="appdivcation/pdf"
                format="PDF"
                name="El herbicida glifosato y sus alternativas"
                downloadname="Ramirez-Muños, 2021. El herbicida glifosato y sus alternativas.pdf"
                weight="5.6 MB"
                cover="descargables/alternativas/materiales//cover-alternativas-glifosato.png" />
        </div>
    </div>
</template>
<script>
import DownloadFile from '@/components/DownloadFile.vue'
export default {
  name: 'PrincipiosArvensesMateriales',
  components: {
      DownloadFile
  },
  mounted() {
    this.$store.commit('setTemaAlternativa', 'Principios del Manejo Ecológico Integral de Arvenses (MEIA)');
    this.$store.commit('setSubtemaAlternativa', 'Materiales de divulgación y capacitación');
  },
}
</script>
